import React, {useState, useEffect} from 'react';
import { AgGridReact } from "ag-grid-react";
import { SBADrawer } from '../../../UiComponents/SBADrawer';
import { SBAComboBox } from '../../../UiComponents/SBADropDown';

const PartnerStep = ({selectedPartner, handleSelectedPartner}) => {
    const [showDrawer, setShowDrawer] = useState(false);
    const [partnershipList, setPartnershipList] = useState([]);
    const [selectedPartnership, setSelectedPartnership] = useState(null);
    const [accountList, setAccountList] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [csList, setCSList] = useState([]);
    const [selectedCs, setSelectedCs] = useState(null);
    const [partnerName, setPartnerName] = useState('');
    const [shortName, setShortName] = useState('');
    const [gridData, setGridData] = useState([
        {id:1, partnerName:'p01', selected: false},
        {id:2, partnerName:'p02', selected: false},
        {id:3, partnerName:'p03', selected: false},
        {id:4, partnerName:'p04', selected: false},
    ]);
    const colDefs = [
        //{headerName:'Partnership Name', field:'partnershipName'},
        {headerName:'Partner Name', field:'partnerName'},
        // {headerName:'Partner Short Name', field:'partnershortName'},
        // {headerName:'Account Name', field:'accountName'},
        // {headerName:'Client Statement Name', field:'clientStatementName'},
        // {headerName:'Date', field:'startDate'},
        {
            headerName:'Action',
            field:'selected',
            cellRenderer: 'agCheckboxCellRenderer',
            cellRendererParams: {
                checkbox: true,
            },
            editable: true,
            width: 100,
        }
    ];
    useEffect(()=>{
        if(selectedPartner){
            const updatedGrid = gridData.map((row) => {
                if(row.id === selectedPartner.id){
                    row = selectedPartner
                }
                return row;
            })
            setGridData(updatedGrid);
        }
    },[selectedPartner]);

    const onCellValueChanged = (params) => {
        if (params.colDef.field === 'selected' && params.newValue) {
          const updatedData = gridData.map((row) => ({
            ...row,
            selected: row.id === params.data.id,
          }));
    
          handleSelectedPartner(params.data);
          setGridData(updatedData);
        }
      };
    return(
      <>
        <div className='container-fluid' style={{paddingTop:0, marginTop:'20px'}}>
            <div className="h4">Add/Select Partner</div>
            <div className='row d-flex justify-content-end' style={{ marginRight:'65px' }}>
            <button
                type="submit"
                className="p-sm-btn"
                onClick={() => setShowDrawer(true)}
                style={{width:'75px'}}
            >
            Add
            </button>
            </div>
            <div className='row w-100'>
            <div
                className="row my-4"
                style={{ height: "500px", width: "100%" }}
            >
              <div className="row col-12 h-100">
                <div
                  className="ag-theme-alpine"
                  style={{ height: "100%", width: "100%", paddingTop: 0 }}
                >
                  <AgGridReact
                    rowData={gridData}
                    columnDefs={colDefs}
                    rowSelection="single"
                    onCellValueChanged={onCellValueChanged}
                    defaultColDef={{ flex: 1, resizable: true, minWidth: 100 }}
                  />
                </div>
              </div>
            </div>
            </div>
        </div>
        <SBADrawer
          open={showDrawer}
          setOpen={setShowDrawer}
          close={false}
          title={"Add New Partner"}
        >
          <div className="row mb-4">
            <div className="col-md-6">
              <div className='d-flex flex-column'>
                <label className="label">Partnership</label>
                <SBAComboBox
                    data={partnershipList}
                    textField={"partnershipName"}
                    valueField={"partnershipId"}
                    value={selectedPartnership}
                    onChange={(e)=>setSelectedPartnership(e.value)}
                    popupSettings={{ className: "modalDD" }}
                    style={{width:"250px"}}
                ></SBAComboBox>
              </div>
            </div>
            <div className="col-md-6">
            <div>
                <label className="label">Partner Name</label>
                <input
                  className="input-default form-control"
                  type="text"
                  Value={partnerName}
                  onChange={(e)=> setPartnerName(e.target.value)}
                  style={{width:"250px"}}
                />
              </div>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-md-6">
            <div>
                <label className="label">Short Name</label>
                <input
                  className="input-default form-control"
                  type="text"
                  Value={shortName}
                  onChange={(e)=> setShortName(e.target.value)}
                  style={{width:"250px"}}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className='d-flex flex-column'>
                <label className="label">Account</label>
                <SBAComboBox
                    data={accountList}
                    textField={"frequencyName"}
                    valueField={"id"}
                    value={selectedAccount}
                    onChange={(e)=>setSelectedAccount(e.value)}
                    popupSettings={{ className: "modalDD" }}
                    style={{width:"250px"}}
                ></SBAComboBox>
              </div>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-md-6">
              <div className='d-flex flex-column'>
                <label className="label">Client Statement</label>
                <SBAComboBox
                    data={csList}
                    textField={"batchName"}
                    valueField={"id"}
                    value={selectedCs}
                    onChange={(e)=>setSelectedCs(e.value)}
                    popupSettings={{ className: "modalDD" }}
                    style={{width:"250px"}}
                ></SBAComboBox>
              </div>
            </div>
          </div>
          <div className="m-1 d-flex justify-content-end mt-2">
            <button className="s-sm-btn mx-1" onClick={()=>setShowDrawer(false)}>Cancel</button>
            <button className="p-sm-btn mx-1" onClick={()=>console.log('Adding new partnership')}>Add</button>
          </div>
        </SBADrawer>
      </>               
    );
};

export default PartnerStep;